import React, { useState, useEffect } from 'react';
import {
  Box, Grid, Typography, Button, Menu, Card, CardContent,
  Table, TableContainer, TableHead, TableBody, TableRow, Divider, BottomNavigation, TablePagination, Paper,Tooltip,MenuItem,Select,FormControl,InputLabel,CircularProgress
} from '@mui/material'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import globalStyles from '../../utils/globalStyles'
import { styled } from '@mui/material/styles';
import axios from 'axios'
import legolasApi from '../../api/legolas'
import WinterOrderList from '../orders/WinterOrderList';
import OrderList from '../orders/OrderList';
import generateToken from '../../utils/generateToken';

import TotalOrder from '../../static/assets/iconDashboardTotalOrders.png';
import AvgOrder from '../../static/assets/iconDashboardAvgOrders.png';
import AvgOrderAmount from '../../static/assets/iconDashboardAvgOrdersAmount.png';
import CodOrder from '../../static/assets/iconDashboardCodOrder.png';
import OnlineOrder from '../../static/assets/iconDashboardOnlineOrders.png';
import TotalOrderAmount from '../../static/assets/iconDashboardTotalOrdersAmount.png';
import TotalOrderQuantity from '../../static/assets/iconDashboardTotalOrdersQuantity.png';
import SKU from '../../static/assets/iconDashboardSKU.png';

import TotalDiscount from '../../static/assets/iconTotalDiscount.png';
import TotalFailedOrder from '../../static/assets/iconTotalFailedOrder.png';
import OrderQtyPendingStock from '../../static/assets/iconOrderQtyPendingStock.png';
import TotalPendingOrder from '../../static/assets/iconTotalPendingOrder.png';
import TotalSlaBreachedOrder from '../../static/assets/iconTotalSlaBreachedOrder.png';
import TotalUnfulfillableOrder from '../../static/assets/iconTotalUnfulfillableOrder.png';



const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    //backgroundColor: '#2b3f7a',
    color: '#000',
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap',
    fontSize: 16
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));



function Dashboard() {
  const localStorageUser = localStorage.getItem('user');
  const user = JSON.parse(localStorageUser);
  console.log("user", user);
  const userid = user.id
  const [tabValue, setTabValue] = React.useState(0);
  const [data, setData] = useState([])
  const [listData, setListData] = React.useState([])
  const [currentItems, setCurrentItems] = useState([]);
  const [totalOrders, setTotalOrders] = React.useState([])
  const [orderData, setOrderData] = useState([]);
  const [bundleData, setBundleData] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState('today'); // Default to 'today'
  //const [bundleDateRange, setBundleDateRange] = useState('today'); // Default to 'today'
  const [searchStatsList, setSearchStatsList] = useState([]);

 const [loading, setLoading] = useState(false);

  const getSearchCount = async () => {
    try {
      const res = await axios.get(`${legolasApi.url}/api/search/count`)
      console.log('search res: ', res.data.data)
      const list = res.data.data
      setListData(list)
    } catch (error) {
      console.error('Error fetching search count:', error);
    }
  };

  // const getOverviewData = async () => {

  //   try {
  //     const data = {
  //       "action": "dashboard"
  //     };
  //     const signedToken = generateToken(data);
  //     const res = await axios.get(`${legolasApi.url}/admin/dashboard/stats/overview`, {
  //       headers: {
  //         'Authorization': `Bearer ${signedToken}`,
  //         'Content-Type': 'application/json'
  //       }
  //     })

  //     console.log('overview res: ', res.data);
  //     const overviewData = res.data;
  //     setTotalOrders(overviewData);
  //   } catch (error) {
  //     console.error('Error fetching overview data:', error);
  //   }
  // };


  const getAllPosts = async () => {
    try {
      const res = await axios.get(`${legolasApi.url}/admin/user/lastorders`)
      const nbaData = res.data.data
      setCurrentItems(nbaData)
    } catch (error) {
      console.error('Error fetching all posts:', error);
    }
  };

  const getOrderDashboard = async (dateRange) => {
    try {
      const res = await axios.post(`${legolasApi.url}/admin/dashboard/order/overviewStats?dateRange=${dateRange}`);
      //console.log('Dashboard data: ', res.data.data)
      setOrderData(res.data.data);
    } catch (error) {
      console.error('Error fetching search count:', error);
    }
  };

   const getBundleOrderDashboard = async (dateRange) => {
    try {
      const res = await axios.post(`${legolasApi.url}/admin/dashboard/order/bundleviewStats?dateRange=${dateRange}`);
      //console.log('Dashboard data: ', res.data.data)
      setBundleData(res.data.data);
    } catch (error) {
      console.error('Error fetching search count:', error);
    }
  };

const getOverviewSearchStats = async () => {
  try {
    const signedToken = generateToken({ action: 'dashboard' });

    const res = await axios.get(
      `${legolasApi.url}/admin/dashboard/searchstats/overview`,
      {
        headers: {
          Authorization: `Bearer ${signedToken}`
        }
      }
    );

    console.log('SearchStats API:', res.data);

    setTotalOrders(res.data.data.overview);
    setSearchStatsList(res.data.data.list); 

  } catch (error) {
    console.error('Error fetching overview data:', error);
  }
};


  useEffect(() => {
    getAllPosts();
    getSearchCount();
   // getOverviewData();
    getOverviewSearchStats();
    getOrderDashboard(selectedDateRange);
    getBundleOrderDashboard(selectedDateRange);
  }, [ selectedDateRange]);

  // const handleDateRangeChange = async (event) => {
  //   const { name, value } = event.target;

  // if (name === "selectedDateRange") {
  //   setSelectedDateRange(value);
  // } else if (name === "bundleDateRange") {
  //   //setBundleDateRange(value);
  // }

  // };



const handleDateRangeChange = (event) => {
  const { name, value } = event.target;
  if (name === "selectedDateRange") {
    setSelectedDateRange(value); // this triggers useEffect
  }
};

useEffect(() => {
  setLoading(true);
  const fetchDashboardData = async () => {
    await Promise.all([
      getOrderDashboard(selectedDateRange),
      getBundleOrderDashboard(selectedDateRange),
    ]);
    setLoading(false);
  };

  // Add artificial delay for smoother loading animation
  const delay = setTimeout(() => {
    fetchDashboardData();
  }, 3000);

  return () => clearTimeout(delay); // Clean up timeout on unmount
}, [selectedDateRange]);



  const dashHeaderBtnStyle = {
    color: '#2b3f7a',
    border: '1px solid #2b3f7a',
    borderRadius: '25px',
    padding: '5px 20px',
    marginRight: '20px',
    textTransform: 'capitalize'
  }

  const headerGridContainerStyle = {
    margin: '0px !important',
    padding: '0 !important',
    backgroundColor: '#fff',
    padding: '15px 30px',
    boxShadow: '0 8px 6px -6px #D3D3D3'
  }

  const cardHeader = {
    fontSize: '1.1rem', color: '#999', fontWeight: 400
  }

  const cardSubheader = {
    fontSize: '1rem', color: '#2b3f7a', fontWeight: 600
  }

  const temporaryOrderData = [
    { name: 'Vipin Negi', items: 1, total: '139.00' },
    { name: 'Shreesha Sudhakar', items: 1, total: '23443.00' },
    { name: 'Hirak Dutta', items: 1, total: '1212.00' },
    { name: 'Hirak Dutta', items: 1, total: '4312.00' }
  ]

  const temporaryCustomerData = [
    { name: 'Hirak Dutta', price: '1', qty: '139' },
    { name: 'Hirak Dutta', price: '2', qty: '140' },
    { name: 'Hirak Dutta', price: '3', qty: '141' },
    { name: 'Hirak Dutta', price: '4', qty: '142' },
    { name: 'Hirak Dutta', price: '5', qty: '143' },
    { name: 'Hirak Dutta', price: '6', qty: '144' },
  ]

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  if (userid === 154) {
    return (<WinterOrderList></WinterOrderList>)
  }
  else if (userid === 155) {
    return <OrderList></OrderList>
  }
  else {
    return (
      <div style={{ width: 'calc(100% - 40px)', display: 'block' }}>
        <Grid container spacing={5} columns={24} sx={{ ...headerGridContainerStyle }}>
          <Grid item xs={8} sx={{
            display: 'flex', justifyContent: 'start', padding: '0 !important', margin: 0, '& .MuiTypography-root': {
              fontWeight: 500
            }
          }}>
            <Typography variant='h4' style={{ marginTop: '10px' }}>
              Dashboard
            </Typography>
          </Grid>
          <Grid item xs={16} sx={{ padding: '0 0 0 25rem !important' }}>
            {/* <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button sx={{ ...dashHeaderBtnStyle }}>
              Advanced Reporting
            </Button>
            <Button sx={{ ...dashHeaderBtnStyle, color: '#fff !important', backgroundColor: '#2b3f7a !important' }}>
              Reload Data
            </Button>
          </Box> */}
          </Grid>
        </Grid>

        <Box sx={{ margin: '25px 30px', width: '97.5%' }}>
          <Grid xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className='dashboard-select'>
            <select style={{ padding: '5px 8px' }} name="selectedDateRange" onChange={handleDateRangeChange} value={selectedDateRange}>
              <option value="today">Today</option>
              <option value="yesterday">Yesterday</option>
              <option value="weekly">Weekly</option>
              <option value="monthly">Monthly</option>
            </select>
          </Grid>
        </Box>

        <Box sx={{ margin: '25px 30px', width: '97.5%' }}>
            {loading ? (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
    <CircularProgress size={25} thickness={4}/>
  </Box>
) : (
            <Grid container spacing={2} columns={12} sx={{ width: '100%' }} rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>

  
            {orderData.map((order, index) => (

              <Grid item className='stats-desktop-width'>
                <Grid className='dashboard-stats-div total-order'>
                  <Grid className='stats-label-div'>
                    <p>Total Orders</p>
                    <h3>{order.totalOrders}</h3>
                  </Grid>
                  <Grid className="stats-icon-div">
                    <img src={TotalOrder} alt='Shababuna' width="120px" className='logo-margin1' />
                  </Grid>
                </Grid>
              </Grid>
            ))}
            {/* <Grid item    className='stats-desktop-width'>
              <Grid className='dashboard-stats-div avg-order'>
              <Grid className='stats-label-div'>
                <p>Total Order Lines</p>
                <h3>752349</h3>
                </Grid>
              <Grid className="stats-icon-div">
              <img src={AvgOrder} alt='Avg. Orders' />
                </Grid>
              </Grid>
            </Grid> */}

            <Grid item className='stats-desktop-width'>
              <Grid className='dashboard-stats-div avg-order-amount'>
                {orderData.map((order, index) => (

                  <Grid className='stats-label-div'>
                    <p>Avg. Order Amount</p>
                    <h3>{Math.round(order.averageOrderAmount)}</h3>
                  </Grid>
                ))}

                <Grid className="stats-icon-div">
                  <img src={AvgOrderAmount} alt='Orders Amount' />
                </Grid>
              </Grid>
            </Grid>

            <Grid item className='stats-desktop-width'>
              <Grid className='dashboard-stats-div total-order-quantity'>
                {orderData.map((order, index) => (
                  <Grid className='stats-label-div'>
                    <p>Total Order Quantity</p>
                    <h3>{order.totalOrderQuantity}</h3>
                  </Grid>
                ))}
                <Grid className="stats-icon-div">
                  <img src={TotalOrderQuantity} alt='COD Orders' />
                </Grid>
              </Grid>
            </Grid>

            <Grid item className='stats-desktop-width'>
              <Grid className='dashboard-stats-div distinct-sku-sold'>
                {orderData.map((order, index) => (
                  <Grid className='stats-label-div'>
                    <p>Distinct SKU Sold</p>
                    <h3>{order.distinctSKUSold}</h3>
                  </Grid>
                ))}
                <Grid className="stats-icon-div">
                  <img src={SKU} alt='COD Orders' />
                </Grid>
              </Grid>
            </Grid>

            {/* <Grid item    className='stats-desktop-width'>
              <Grid className='dashboard-stats-div online-order'>
              <Grid className='stats-label-div'>
                <p>Avg. Lines Per Order</p>
                <h3>752349</h3>
                </Grid>
              <Grid className="stats-icon-div">
              <img src={AvgOrder} alt='COD Orders' />
                </Grid>
              </Grid>
            </Grid> */}

            <Grid item className='stats-desktop-width'>
              <Grid className='dashboard-stats-div total-order-amount'>
                {orderData.map((order, index) => (

                  <Grid className='stats-label-div'>
                    <p>Total Order Amount</p>
                    <h3>{Math.round(order.totalOrderAmount)}</h3>
                  </Grid>
                ))}

                <Grid className="stats-icon-div">
                  <img src={TotalOrderAmount} alt='COD Orders' />
                </Grid>
              </Grid>
            </Grid>




            <Grid item className='stats-desktop-width'>
              <Grid className='dashboard-stats-div cod-order'>
                {orderData.map((order, index) => (
                  <Grid className='stats-label-div'>
                    <p>% COD Orders</p>
                    <h3>{parseFloat(order.codOrderPercentage).toFixed(2)}</h3>
                  </Grid>
                ))}
                <Grid className="stats-icon-div">
                  <img src={CodOrder} alt='COD Orders' />
                </Grid>
              </Grid>
            </Grid>


            <Grid item className='stats-desktop-width'>
              <Grid className='dashboard-stats-div total-discount'>
                {orderData.map((order, index) => (

                  <Grid className='stats-label-div'>
                    <p>Total Discounts</p>
                    <h3>{Math.round(order.totalDiscount)}</h3>
                  </Grid>
                ))}
                <Grid className="stats-icon-div">
                  <img src={TotalDiscount} alt='Shababuna' width="120px" className='logo-margin1' />
                </Grid>
              </Grid>
            </Grid>
       <Grid container spacing={5} columns={24} sx={{ ...headerGridContainerStyle }}>
  <Grid item xs={24}>
    <Box sx={{ ml: -5, pr: 1, pt: 1 }}>
      <Typography variant="h5" sx={{ mb: 3 }}>
         Top Bundle's Sales
      </Typography>
      {/* <FormControl size="small" sx={{ mb: 3, minWidth: 180 }}>
        <InputLabel>Date Range</InputLabel>
        <Select
          name="bundleDateRange"
          label="Date Range"
          value={bundleDateRange}
          onChange={handleDateRangeChange}
        >
          <MenuItem value="today">Today</MenuItem>
          <MenuItem value="yesterday">Yesterday</MenuItem>
          <MenuItem value="weekly">Weekly</MenuItem>
          <MenuItem value="monthly">Monthly</MenuItem>
        </Select>
      </FormControl> */}

      <TableContainer component={Paper} sx={{ maxHeight: 600 }}>
        <Table stickyHeader>
          <TableHead>
       <TableRow>
        <TableCell sx={{ color: '#2b3f7a' }}><strong>Bundle Name</strong></TableCell>
        <TableCell sx={{ color: '#2b3f7a' }}><strong>Bundle SKU</strong></TableCell>
        <TableCell align="right" sx={{ color: '#2b3f7a' }}><strong>Qty</strong></TableCell>
        <TableCell align="right" sx={{ color: '#2b3f7a' }}><strong>Sales (In Price)</strong></TableCell>
      </TableRow>
          </TableHead>
          <TableBody>
            {bundleData.length === 0 ? (
    <TableRow>
      <TableCell colSpan={4} align="center">
        No record found
      </TableCell>
    </TableRow>
  ) : ( bundleData.map((order, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Tooltip title={order.BundleName}>
                    <span style={{
                      whiteSpace: 'normal',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: 'inline-block',
                      maxWidth: '300px',
                      wordBreak: 'break-word',
                      overflowWrap: 'break-word',
                    }}>
                      {order.BundleName}
                    </span>
                  </Tooltip>
                </TableCell>
                <TableCell>{order.BundleSKU}</TableCell>
                <TableCell align="right">{order.Qty}</TableCell>
                <TableCell align="right">{parseFloat(order.Sales).toFixed(2)}</TableCell>
              </TableRow>
              ))
            )}
          </TableBody>
        </Table>
        
      </TableContainer>
     
    </Box>
    
  </Grid>
  
</Grid>


            {/* <Grid item   className='stats-desktop-width'>
              <Grid className='dashboard-stats-div order-qty-pending-stock'>
              <Grid className='stats-label-div'>
                <p>Order Qty Pending Stock</p>
                <h3>752349</h3>
                </Grid>
              <Grid className="stats-icon-div">
              <img src={OrderQtyPendingStock} alt='Order Qty Pending Stock' />
                </Grid>
              </Grid>
            </Grid> */}

            {/* <Grid item    className='stats-desktop-width'>
              <Grid className='dashboard-stats-div total-pending-order'>
              <Grid className='stats-label-div'>
                <p>Total Pending Order</p>
                <h3>752349</h3>
                </Grid>
              <Grid className="stats-icon-div">
              <img src={TotalPendingOrder} alt='Avg. Orders' />
                </Grid>
              </Grid>
            </Grid> */}

            {/* <Grid item    className='stats-desktop-width'>
              <Grid className='dashboard-stats-div unfulfillable-line-level-order'>
              <Grid className='stats-label-div'>
                <p>Unfulfillable Line Level Order</p>
                <h3>752349</h3>
                </Grid>
              <Grid className="stats-icon-div">
              <img src={TotalUnfulfillableOrder} alt='Unfulfillable Line Level Order' />
                </Grid>
              </Grid>
            </Grid> */}


            {/* <Grid item   className='stats-desktop-width'>
              <Grid className='dashboard-stats-div total-unfulfillable-order'>
              <Grid className='stats-label-div'>
                <p>Total Unfulfillable Order</p>
                <h3>752349</h3>
                </Grid>
              <Grid className="stats-icon-div">
              <img src={TotalUnfulfillableOrder} alt='Total Unfulfillable Order' />
                </Grid>
              </Grid>
            </Grid> */}

            {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={3} xxl={3}>
              <Grid className='dashboard-stats-div avg-order'>
              <Grid className='stats-label-div'>
                <p>Avg. Order</p>
                <h3>752349</h3>
                </Grid>
              <Grid className="stats-icon-div">
              <img src={AvgOrder} alt='Avg. Orders' />
                </Grid>
              </Grid>
            </Grid> */}

            {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={3} xxl={3}>
              <Grid className='dashboard-stats-div online-order'>
              <Grid className='stats-label-div'>
                <p>Online Order</p>
                <h3>752349</h3>
                </Grid>
              <Grid className="stats-icon-div">
              <img src={OnlineOrder} alt='COD Orders' />
                </Grid>
              </Grid>
            </Grid> */}

            {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={3} xxl={3}>
              <Grid className='dashboard-stats-div avg-order'>
              <Grid className='stats-label-div'>
                <p>Avg. Order</p>
                <h3>752349</h3>
                </Grid>
              <Grid className="stats-icon-div">
              <img src={AvgOrder} alt='Avg. Orders' />
                </Grid>
              </Grid>
            </Grid> */}

            {/* <Grid item   className='stats-desktop-width'>
              <Grid className='dashboard-stats-div total-sla-breached-order'>
              <Grid className='stats-label-div'>
                <p>Total SLA Breached Order</p>
                <h3>752349</h3>
                </Grid>
              <Grid className="stats-icon-div">
              <img src={TotalSlaBreachedOrder} alt='Total SLA Breached Order' />
                </Grid>
              </Grid>
            </Grid> */}

            {/* <Grid item   className='stats-desktop-width'>
              <Grid className='dashboard-stats-div total-failed-order'>
              <Grid className='stats-label-div'>
                <p>Total Failed Order</p>
                <h3>752349</h3>
                </Grid>
              <Grid className="stats-icon-div">
              <img src={TotalFailedOrder} alt='Total Failed Order' />
                </Grid>
              </Grid>
            </Grid> */}

            {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={3} xxl={3}>
              <Grid className='dashboard-stats-div online-order'>
              <Grid className='stats-label-div'>
                <p>Online Order</p>
                <h3>752349</h3>
                </Grid>
              <Grid className="stats-icon-div">
              <img src={OnlineOrder} alt='COD Orders' />
                </Grid>
              </Grid>
            </Grid> */}

            {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={3} xxl={3}>
              <Grid className='dashboard-stats-div total-order-quantity'>
              <Grid className='stats-label-div'>
                <p>Total Order Quantity</p>
                <h3>752349</h3>
                </Grid>
              <Grid className="stats-icon-div">
              <img src={TotalOrderQuantity} alt='COD Orders' />
                </Grid>
              </Grid>
            </Grid> */}

            {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={3} xxl={3}>
              <Grid className='dashboard-stats-div distinct-sku-sold2'>
              <Grid className='stats-label-div'>
                <p>Distinct SKU Sold</p>
                <h3>752349</h3>
                </Grid>
              <Grid className="stats-icon-div">
              <img src={SKU} alt='COD Orders' />
                </Grid>
              </Grid>
            </Grid> */}

          </Grid>
          )}

        </Box>




        <Box sx={{ margin: '25px 30px' }}>
          {/* <Typography variant='subtitle1' sx={{ fontSize: '1.2rem', color: '#808080' }}>Advanced Reporting</Typography>
        <Typography variant='body1' sx={{ fontSize: '1rem', color: '#808080' }}>
          Gain new insights and take command of your business performance, using our dynamic product, order and
          customer reports alloted to your customer data
        </Typography> */}
        </Box>


        <Box sx={{ margin: '25px 30px', width: '97%' }} >
          <Grid container spacing={2} columns={12} sx={{ width: '100%' }} rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid item sx={10} xs={12} sm={12} md={12} lg={5} xl={5}>
              <Card sx={{ minWidth: '300px', width: '100%', marginBottom: '20px' }}>
                {/* <Card sx={{ minWidth: 300, marginBottom: '20px' }}> */}
                <CardContent>
                  <Typography variant='subtitle1' sx={cardHeader}>
                    Lifetime Sales
                  </Typography>
                  <Typography variant='subtitle1' sx={cardSubheader}>
                    {totalOrders && totalOrders.totalSales !== undefined ? `SAR ${parseFloat(totalOrders.totalSales).toLocaleString()}` : 'Loading...'}
                  </Typography>
                  <Divider sx={{ paddingTop: '0px', paddingBottom: '.5px', marginTop: '8px', marginBottom: '8px' }} />
                  <Typography variant='subtitle1' sx={cardHeader}>
                    Total  Delivered Orders
                  </Typography>
                  <Typography variant='subtitle1' sx={cardSubheader}>
                    {totalOrders && totalOrders.totalOrders !== undefined ? `${totalOrders.totalOrders.toLocaleString()}` : 'Loading...'}
                  </Typography>
                </CardContent>
              </Card>
              {/* <Card sx={{ width: '30vw', marginBottom: '20px' }}>
                <CardContent>
                  <Typography variant='subtitle1' sx={{ color: '#2b3f7a', fontSize: '1.1rem', fontWeight: '400' }}>
                    Last Five Orders
                  </Typography> */}
              {/* <TableContainer sx={{ paddingTop: '20px' }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <StyledTableCell align='left'>Customer</StyledTableCell>
                          <StyledTableCell align='left'> Total Items</StyledTableCell>
                          <StyledTableCell align='left'>Total Price(SAR)</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {currentItems && currentItems.map((currentItems, index) => {
                          return (
                            <StyledTableRow id={index}>
                              <StyledTableCell>{currentItems.customers}</StyledTableCell>
                              <StyledTableCell align='center'>{currentItems.total_items}</StyledTableCell>
                              <StyledTableCell align='center'>{currentItems.total_price}</StyledTableCell>
                            </StyledTableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent> */}
              {/* </Card> */}
               {/* <Card sx={{ width: '100%', marginBottom: '20px', }}>  */}

               <Card sx={{ minWidth: '330px', width: '100%', marginBottom: '20px' }}>
                <CardContent style={{ overflow: 'auto', maxHeight: '300px', minHeight: '150px' }} className='scrollable-div'>
                  <Typography variant='subtitle1' sx={{ color: '#2b3f7a', fontSize: '1.1rem', fontWeight: '400' }}>
                    Last Search Terms
                  </Typography>
                   <TableContainer sx={{ paddingTop: '20px', overflow:'auto', minWidth:'300px' }}> 
                    {/* <TableContainer sx={{ paddingTop: '20px', }}> */}
                    <Table style={{ minWidth: '600px' }}>
                      <TableHead>
                        <TableRow>
                          <StyledTableCell align='left' sx={{ position: 'sticky',top: 0,backgroundColor: '#fff',zIndex: 1,width: '40%'}}>Search Term</StyledTableCell>
                          <StyledTableCell align='left' sx={{ position: 'sticky',top: 0,backgroundColor: '#fff',zIndex: 1,width: '30%'}}>Email</StyledTableCell>
                          <StyledTableCell align='center' sx={{ position: 'sticky',top: 0, backgroundColor: '#fff', zIndex: 1, width: '15%'}}>Results</StyledTableCell>
                          <StyledTableCell align='center' sx={{ position: 'sticky',top: 0,backgroundColor: '#fff',zIndex: 1,width: '15%'}}>Users</StyledTableCell>

                          
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {searchStatsList.map((list, index) => {

                          return (
                            <StyledTableRow key={index}>
                              <StyledTableCell align='left'>{list.term}</StyledTableCell>
                              <StyledTableCell align='left'>{list.emails ? list.emails.join(', ') : '-'}</StyledTableCell>
                              <StyledTableCell align='center'>{list.results}</StyledTableCell>
                              <StyledTableCell align='center'>{list.users}</StyledTableCell>

                            </StyledTableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer> 
                 </CardContent> 
              </Card> 
            </Grid>
            {/* <Card sx={{ width: '30vw', marginBottom: '20px' }}>
                <CardContent>
                  <Typography variant='subtitle1' sx={{ color: '#2b3f7a', fontSize: '1.1rem', fontWeight: '400' }}>
                    Last Five Orders
                  </Typography> */}
            {/* <TableContainer component={Paper} sx={{ paddingTop: '20px' }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell align='left'>Customer</TableCell>
                                <TableCell align='left'>Total Items</TableCell>
                                <TableCell align='left'>Total Price(SAR)</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(rowsPerPage > 0
                                ? currentItems.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                : currentItems
                              ).map((item, index) => (
                                <TableRow key={index}>
                                  <TableCell>{item.customers}</TableCell>
                                  <TableCell align='center'>{item.total_items}</TableCell>
                                  <TableCell align='center'>{item.total_price}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                          <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component='div'
                            count={currentItems.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                          />
                        </TableContainer> */}
            {/* <TableContainer sx={{ paddingTop: '20px' }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <StyledTableCell align='left'>Customer</StyledTableCell>
                          <StyledTableCell align='left'> Total Items</StyledTableCell>
                          <StyledTableCell align='left'>Total Price(SAR)</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {currentItems && currentItems.map((currentItems, index) => {
                          return (
                            <StyledTableRow id={index}>
                              <StyledTableCell>{currentItems.customers}</StyledTableCell>
                              <StyledTableCell align='center'>{currentItems.total_items}</StyledTableCell>
                              <StyledTableCell align='center'>{currentItems.total_price}</StyledTableCell>
                            </StyledTableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent> */}
            {/* <Box sx={{ width: 0, display: 'flex', justifyContent: 'left', textAlign: 'right', flexDirection: 'row', flexShrink: 0, height: 60, resize: 'both', margin: 0, padding: 1, columnGap: '2px' }}>
                <ReactPaginate nextLabel=">" previousLabel="< " onPageChange={handlePageClick} pageCount={pageCount} containerClassName="pagination"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  activeClassName="active"
                  renderOnZeroPageCount={null} />
              </Box> */}
            {/* </Card> */}

            <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
              {/* <Grid item sx={14}> */}
              {/* <Card sx={{ width: '60vw', marginBottom: '20px' }}> */}
              <Card style={{ marginBottom: '20px', width: '[100%' }}>
                <CardContent>
                  <Typography variant='subtitle1' sx={{ color: '#2b3f7a', fontSize: '1.1rem', fontWeight: '400' }}>
                    Last Five Orders
                  </Typography>
                  {/* <TableContainer component={Paper} sx={{ paddingTop: '20px' }}>
                          <Table>
                            <TableHead>
                              <TableRow>
                                <TableCell align='left'>Customer</TableCell>
                                <TableCell align='left'>Total Items</TableCell>
                                <TableCell align='left'>Total Price(SAR)</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {(rowsPerPage > 0
                                ? currentItems.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                : currentItems
                              ).map((item, index) => (
                                <TableRow key={index}>
                                  <TableCell>{item.customers}</TableCell>
                                  <TableCell align='center'>{item.total_items}</TableCell>
                                  <TableCell align='center'>{item.total_price}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                          <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component='div'
                            count={currentItems.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                          />
                        </TableContainer> */}
                  {/* <TableContainer sx={{ paddingTop: '20px',width: '60vw' }}> */}
                  <TableContainer sx={{ paddingTop: '20px', width: '100%' }} style={{ overflow: 'auto' }}>
                    <Table style={{ minWidth: '600px' }}>
                      <TableHead>
                        <TableRow>
                          <StyledTableCell>Customer</StyledTableCell>
                          <StyledTableCell align='center'> Total Items</StyledTableCell>
                          <StyledTableCell align='center'>Total Price (SAR)</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {currentItems && currentItems.map((currentItems, index) => {
                          return (
                            <StyledTableRow id={index}>
                              <StyledTableCell>{currentItems.customers}</StyledTableCell>
                              <StyledTableCell align='center'>{currentItems.total_items}</StyledTableCell>
                              <StyledTableCell align='center'>{parseFloat(currentItems.total_price).toFixed(2).toLocaleString()}</StyledTableCell>
                            </StyledTableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
                {/* <Box sx={{ width: 0, display: 'flex', justifyContent: 'left', textAlign: 'right', flexDirection: 'row', flexShrink: 0, height: 60, resize: 'both', margin: 0, padding: 1, columnGap: '2px' }}>
                <ReactPaginate nextLabel=">" previousLabel="< " onPageChange={handlePageClick} pageCount={pageCount} containerClassName="pagination"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  activeClassName="active"
                  renderOnZeroPageCount={null} />
              </Box> */}
                {/* </Card> */}
                {/* <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant='subtitle1' sx={{ fontSize: '1.1rem', color: '#2b3f7a', }}>
                    Total Revenue
                  </Typography>
                  <Typography variant='subtitle1' sx={{ fontSize: '0.9rem', color: '#2b3f7a' }}>
                    Last 24 Hrs
                  </Typography>
                </Box>
                <Box>
                  <BottomNavigation
                    showLabels
                    value={tabValue}
                    onChange={(event, newValue) => {
                      setTabValue(newValue);
                    }}
                    sx={globalStyles.bottomNavigationMenu}
                  >
                    <BottomNavigationAction label="Orders" />
                    <BottomNavigationAction label="Amounts" />
                  </BottomNavigation>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', paddingTop: '20px' }}>
                  <Box sx={{ display: 'block' }}>
                    <Typography variant='subtitle1' sx={{ fontSize: '1rem', fontWeight: 500 }}>Revenue</Typography>
                    <Typography variant='subtitle1' sx={{ fontSize: '1.1rem', color: '#2b3f7a', fontWeight: 600 }}>SAR 0.00</Typography>
                  </Box>
                  <Box sx={{ display: 'block' }}>
                    <Typography variant='subtitle1' sx={{ fontSize: '1rem', fontWeight: 500 }}>Tax</Typography>
                    <Typography variant='subtitle1' sx={{ fontSize: '1.1rem', color: '#000', fontWeight: 600 }}>SAR 0.00</Typography>
                  </Box>
                  <Box sx={{ display: 'block' }}>
                    <Typography variant='subtitle1' sx={{ fontSize: '1rem', fontWeight: 500 }}>Shipping</Typography>
                    <Typography variant='subtitle1' sx={{ fontSize: '1.1rem', color: '#000', fontWeight: 600 }}>SAR 0.00</Typography>
                  </Box>
                  <Box sx={{ display: 'block' }}>
                    <Typography variant='subtitle1' sx={{ fontSize: '1rem', fontWeight: 500 }}>Quantity</Typography>
                    <Typography variant='subtitle1' sx={{ fontSize: '1.1rem', color: '#000', fontWeight: 600, textAlign: 'center' }}>0</Typography>
                  </Box>
                </Box> */}
                {/* </CardContent> */}
              </Card>
              {/* <Card sx={{ marginTop: '20px' }}>
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <Typography variant='subtitle1' sx={{ fontSize: '1.1rem', color: '#2b3f7a', }}>
                    Customer Details
                  </Typography>
                </Box>
                <Box>
                  <BottomNavigation
                    showLabels
                    value={tabValue}
                    onChange={(event, newValue) => {
                      setTabValue(newValue);
                    }}
                    sx={globalStyles.bottomNavigationMenu}
                  >
                    <BottomNavigationAction label="Bestsellers" />
                    <BottomNavigationAction label="Most Viewed" />
                    <BottomNavigationAction label="New Customers" />
                    <BottomNavigationAction label="Customers" />
                    <BottomNavigationAction label="Reviews" />
                  </BottomNavigation>
                </Box>
                <Box sx={{ paddingTop: '20px' }}>
                  <TableContainer sx={{ paddingTop: '20px' }}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <StyledTableCell align='left'>Product</StyledTableCell>
                          <StyledTableCell align='center'>Price</StyledTableCell>
                          <StyledTableCell align='center'>Quantity</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {temporaryCustomerData.map((data, index) => {
                          return (
                            <StyledTableRow id={index}>
                              <StyledTableCell align='left'>{data.name}</StyledTableCell>
                              <StyledTableCell align='center'>{data.price}</StyledTableCell>
                              <StyledTableCell align='center'>{data.qty}</StyledTableCell>
                            </StyledTableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </CardContent>
            </Card> */}
            </Grid>
          </Grid>
        </Box>
      </div>
    )
  }

};

export default Dashboard